// extracted by mini-css-extract-plugin
export var hideEditor = "_l9-2";
export var infoIcon = "_l9-3";
export var label = "_l9-1";
export var labelContainer = "_l9-0";
export var readonlyText = "_l9-4";